function setTextFieldValue(element, value) {
  if (element.isContentEditable) {
    element.innerHTML = value;
  } else {
    element.value = value;
  }
}

export { setTextFieldValue as s };
